import { Component, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {EntityLineHeader} from '../../entity/entity-line-header';
import {EntityUtils} from '../../utils/entity-utils';
import {EntityLineService} from '../../services/entity-line-service';
import {EntityService} from '../../services/entity-service';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogRef} from '@angular/material/dialog';

import {MatButton} from '@angular/material/button';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'line-summary-dialog',
    templateUrl: './line-summary-dialog.component.html',
    styleUrls: ['./line-summary-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, MatDialogActions, MatButton]
})
export class LineSummaryDialogComponent {
  private readonly entityLineService = inject(EntityLineService);
  private readonly entityService = inject(EntityService);
  readonly dialogRef = inject<MatDialogRef<LineSummaryDialogComponent>>(MatDialogRef);
  private readonly data = inject(MAT_DIALOG_DATA);


  private readonly loadComplete = signal<boolean>(false);
  private readonly frozen = signal<boolean>(undefined!);
  private readonly approved = signal<boolean>(undefined!);
  private readonly stockUnit = signal<boolean>(false);
  public entityLine: EntityLineHeader;

  constructor
  () {
    const data = this.data;

    this.entityLine = data.line as EntityLineHeader;
    this.entityService.getEntityByKey(this.entityLine.key).subscribe(result => {
      this.frozen.set(result.frozen);
      this.approved.set(result.approvalStatus == 'Approved');
      this.stockUnit.set(EntityUtils.isStockUnitLine(result, this.entityLine));
      this.loadComplete.set(true);
    });
  }

  public preventUpdate(): boolean {
    return this.entityLine.configured || this.stockUnit() || !this.loadComplete() || this.frozen() || this.approved();
  }

  public isStockUnit(): boolean {
    return this.stockUnit();
  }

  public saveAndClose(): void {
    this.entityLineService.updateQuantity(this.entityLine).subscribe(result => {
      this.dialogRef.close(result);
    });
  }

  public cancel(): void {
    this.dialogRef.close(null);
  }

}
